import { Component, OnInit, Input} from '@angular/core';
import { Inject } from '@angular/core';
import { MODAL_REF, ModalRef } from 'src/app/services/modal/modal-ref.token';
import { OrganizationService } from 'src/app/services/organization/organization.service';
import { UserService } from 'src/app/services/user/user.service';
import { FeatureSwitchService } from 'src/app/services/feature-switch/feature-switch.service';
import { LocalStorageService } from 'src/app/services/local-storage/local-storage.service';

@Component({
    selector: 'app-account-settings',
    templateUrl: './account-settings.component.html',
    styleUrls: ['./account-settings.component.scss'],
    standalone: false
})
export class AccountSettingsComponent implements OnInit {
@Input() showOrg: boolean;
showType: string;
  constructor(
    public featureSwitch: FeatureSwitchService,
    public user: UserService,
    public organization: OrganizationService,
    private localStorage: LocalStorageService,
    @Inject(MODAL_REF) private modalRef: ModalRef,
  ) { }

  ngOnInit() {
    this.showType = this.localStorage.getItem('showType');
  }

  public signOut() {
    this.user.logout();
    this.modalRef.dismiss();
  }

  public dismissModal(id) {
    this.showType = id;
    this.localStorage.setItem('showType', id);
    this.modalRef.dismiss(this.showType);
  }

}
